(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-usp-bar"] && !window.DesignMode) return;
  try {
    
let swiperInstancesMob = [];
let swiperInstancesDtp = [];

// Initialize Swiper instances
let swiperMob = document.querySelector('.usp-mob');
let swiperDtp = document.querySelector('.usp-dtp');
let swiperContainersMob = swiperMob.querySelectorAll('.swiper-container');
let swiperContainersDtp = swiperDtp.querySelectorAll('.swiper-container');

// Initialize counter for tracking swiper initialization
let initializedSwipers = 0;
const totalSwipers = swiperContainersMob.length + swiperContainersDtp.length;

function checkInitialization() {
  initializedSwipers++;
  if (initializedSwipers === totalSwipers) {
    // All swipers are initialized, add class to show them
    swiperMob.classList.add('initialized');
    swiperDtp.classList.add('initialized');
    
    // Start autoplay after fade in
    setTimeout(() => {
      setInterval(autoplayMob, 3000);
      setInterval(autoplayDtp, 3000);
    }, 500); // Wait for fade in to complete
  }
}

swiperContainersMob.forEach((container, index) => {
  let swiper = new Swiper(container, {
    direction: 'vertical',
    slidesPerView: 1,
    autoplay: false,
    loop: true,
    height: 50,
    allowTouchMove: false,
    effect: 'slide',
    on: {
      init: checkInitialization
    }
  });

  swiperInstancesMob.push(swiper);
});

swiperContainersDtp.forEach((container, index) => {
  let swiper = new Swiper(container, {
    direction: 'vertical',
    slidesPerView: 1,
    autoplay: false,
    loop: true,
    height: 50,
    allowTouchMove: false,
    effect: 'slide',
    on: {
      init: checkInitialization
    }
  });

  swiperInstancesDtp.push(swiper);
});

// Define autoplay functions
let autoplayMob = () => {
  swiperInstancesMob.forEach((swiper, index) => {
    setTimeout(() => {
      swiper.slideNext();
    }, index * 205);
  });
};

let autoplayDtp = () => {
  swiperInstancesDtp.forEach((swiper, index) => {
    setTimeout(() => {
      swiper.slideNext();
    }, index * 205);
  });
};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
